<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考场名称:">
          <el-input v-model="listQuery['filter[name]']" clearable placeholder="考场名称"></el-input>

        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
          <el-button type="success" size="medium" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="code" label="考场编号">
      </el-table-column>
      <el-table-column prop="name" label="考场名称" >
      </el-table-column>
      <el-table-column prop="address" label="地址" >
      </el-table-column>
      <el-table-column prop="floor" label="楼层" >
      </el-table-column>
      <el-table-column prop="room_number" label="房号" >
      </el-table-column>
      <el-table-column prop="max_num" label="可容纳人数" >
      </el-table-column>
      <el-table-column prop="name" label="描述" >
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="warning" size="small"  @click="handleEdit(scope)">编辑</el-button>
          <el-button type="danger" size="small" @click="handleDelete(scope)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page" @pagination="getData"/>

    </div>
    <el-dialog :visible.sync="dialogVisible" :title="dialogType==='edit'?'编辑考场':'新增考场'">
      <el-form :model="room" label-width="120px" label-position="left">
        <el-form-item label="名称" prop="name" required>
          <el-input v-model="room.name" placeholder="输入名称"/>
        </el-form-item>
                <el-form-item label="关联摄像机" >
                  <el-select multiple v-model="room.vcr_id" @change="selectChange" placeholder="请选择">
                    <el-option
                      v-for="item in vcrList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
        <el-form-item label="描述" >
          <el-input v-model="room.description" placeholder="描述"/>
        </el-form-item>
        <el-form-item label="地址" >
          <el-input v-model="room.address" placeholder="地址"/>
        </el-form-item>
        <el-form-item label="所在楼层" >
          <el-input v-model="room.floor" placeholder="所在楼层"/>
        </el-form-item>
        <el-form-item label="房号" >
          <el-input v-model="room.room_number" placeholder="房号"/>
        </el-form-item>
        <el-form-item label="户型" >
          <el-input v-model="room.house_type" placeholder="户型"/>
        </el-form-item>
        <el-form-item label="朝向" >
          <el-input v-model="room.orientation" placeholder="朝向"/>
        </el-form-item>
        <el-form-item label="可用面积" >
          <el-input v-model="room.proportion" placeholder="可用面积"/>
        </el-form-item>
        <el-form-item label="最大容纳人数" >
          <el-input v-model="room.max_num" placeholder="最大容纳人数"/>
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button type="danger" @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmSave">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    export default {
        components: { Pagination },
  props: {

  },
  data() {
    return {
        room:{},
        roomList:[],
        vcrList:[],
        total:0,
        dialogType:'new',
        dialogVisible:false,
        listQuery: {
            page: 1,
            per_page:20
        },
      tableData: []
    };
  },
  computed: {

  },
  created() {
    this.getData();
    this.getVcr();
  },
  methods: {

      selectChange(){
          this.$forceUpdate()
      },
    search() {
      this.listQuery.page = 1;
      this.getData()
    },
      getVcr(){
        this.$http.getVcrs({page_size:100000}).then(res=>{
            this.vcrList=res.data;
        })
      },
    // 获取全部的课程列表
    getData() {
      this.$http.getRooms( this.listQuery)
        .then(res => {
          this.tableData = res.data;
            this.total = res.meta.total;
        })
        .catch(err => {
          console.log(err);
        })
    },
      handleAdd() {
          this.room = {};
          this.dialogType = 'new';
          this.dialogVisible = true
      },
      handleEdit(scope) {
          this.dialogType = 'edit';
          this.dialogVisible = true;
          this.$http.getRoom(scope.row.id,{include:'vcr'}).then(res=>{
              const  vcrs=[];
              this.room =res.data
              this.room.vcr.forEach((i)=>{
                  vcrs.push(i.id)
              })
              this.room.vcr_id =vcrs
              delete this.room.vcr
          })
      },
      confirmSave(){
          const isEdit = this.dialogType === 'edit'
          if (isEdit) {
              this.$http.updateRoom(this.room.id, this.room).then(res => {
                  this.dialogVisible = false
                  this.$notify({
                      title: 'Success',
                      message: '操作成功！',
                      type: 'success'
                  });
                  this.getData()
              })
          } else {
              this.$http.addRoom(this.room).then(res => {
                  this.dialogVisible = false
                  this.$notify({
                      title: 'Success',
                      message: '操作成功！',
                      type: 'success'
                  })
                  this.getData()
              })
          }
      },
      handleDelete({$index, row}) {
          this.$confirm('确定要删除此条吗?', '警告', {
              confirmButtonText: '删除',
              cancelButtonText: '取消',
              type: 'warning'
          })
              .then(() => {
                  this.$http.deleteRoom(row.id).then(res => {
                      this.tableData.splice($index, 1)
                      this.$message({
                          type: 'success',
                          message: '删除成功!'
                      })
                  });

              })
              .catch(err => {
                  console.error(err)
              })
      },
  },
};
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/resourceManage/rooms.vue